import { isValidNumber, ObjectAccessor } from '@dateam/ark';
import { parseObservationField } from './shared';
import { RecordValue, ValidationError } from './types';

/*
 ** Accident climatique - échaudage
 ** - count: Comptage // /50 grappes
 **     0 <= Value <= 50
 ** - intensity: Intensité // %
 **     0 <= Value <= 100
 */

type CurrentObservation = App.Observation11;
type CurrentApiObservation = App.Api.Observation11;

export const validate = (
    observation: CurrentObservation,
    _: App.Plot
): Record<never, never> | Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError> => {
    const validation = {} as Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError>;

    const { ignored, count, intensity } = observation;

    if (ignored === true) return validation;

    if (count != null) {
        if (!isValidNumber(count) || count < 0 || count > 50) {
            validation.count = {
                field: 'count',
                type: 'error',
                code: 'format'
            };
        }
    }

    if (intensity != null) {
        if (!isValidNumber(intensity) || intensity < 0 || intensity > 100) {
            validation.intensity = {
                field: 'intensity',
                type: 'error',
                code: 'format'
            };
        }
    }

    return validation;
};

export const parse = (observation: CurrentApiObservation): CurrentObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        count,
        intensity
    } = observation;
    const parsedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        isSyncing: false,
        isValid: true,
        hasChanged: false
    } as CurrentObservation;

    parsedObs.count = parseObservationField(count);
    parsedObs.intensity = parseObservationField(intensity);

    return parsedObs;
};

export const map = (observation: CurrentObservation): CurrentApiObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        count,
        intensity
    } = observation;
    const mappedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn
    } as CurrentApiObservation;

    mappedObs.count = count !== undefined ? new RecordValue(count) : null;
    mappedObs.intensity = intensity !== undefined ? new RecordValue(intensity) : null;

    return mappedObs;
};